module.exports = __webpack_public_path__ + "static/media/1.ea736675.jpg";